import { Alert, AlertTitle, Container, LinearProgress, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { CasUserContext } from "../../services/casUserContext";
import AlertService from "../../services/AlertService";
import CatalogService from "../../services/CatalogService";
import { Unidad } from "../../interfaces/Unidad";
import WebOmniProjectsComp from "../../componentes/Dashboard/WebOmniProjects";

const alertaService = new AlertService();
const catalogService = new CatalogService();

export const DashBoardOmniProjectsPage:React.FC<{}> = () => {
    const casUserContext = useContext(CasUserContext);
    const userData = casUserContext.userData;
    let [ready,setReady] = useState(false);
    let [auth,setAuth] = useState(true);
    let [codacad,setCodacad] = useState("");
    const [unidades,setUnidades] = useState<Array<Unidad>>([])
    const id = "ReportSection6df9d13520be11bd6aeb";

    //#region Seccion Funciones
    const fetchData = async () =>{
        try{
            alertaService.showLoading("Cargando...");
            await catalogService.obtenerCatalogoUnidades()
             .then((data) => {
                getCodAcad(userData.idunidad);
                setAuth(userData.autorizado > 0);
                setUnidades(data.objDatos)
            })
             .catch((error) => console.error(error))
            setReady(true);
            alertaService.hideLoading();                
        }catch(error){
            console.error('Error:',error);
            alertaService.hideLoading();
            alertaService.alertaAdvertencia('Error','Ocurrio un error al momento de cargar la información.');
        }
      };
    
      const getCodAcad = (id:number) =>{
        let codacad = "";
        if(unidades.length > 0){
            codacad = unidades.find(x => x.idunidad ===id)?.codacad || "";
            setCodacad(codacad);
        }          
      }
      //#endregion
    //#region Seccion Carga

    useEffect(() => {
        fetchData();
    },[userData]);
    //#endregion
    
    return(
        <Container sx={{mt:2}}>
        <>
            {ready ?
            <WebOmniProjectsComp autorizado={auth} roles={userData.roles} usuario={userData.netId} unidad={userData.idunidad} nombres={userData.nombres} apellidos={userData.apellidos} />
            :
            <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
                <LinearProgress color="secondary" />
            </Stack>}
          </>
        </Container>
    );
}